import React, { useState } from 'react';
import { DragDropContext, Draggable } from 'react-beautiful-dnd';
import StrictModeDroppable from '../../../../../../../../components/dnd/StrictModeDroppable';
import GripIcon from '../../../../../../../../components/Icons/GripIcon';
import { postReorderOptions } from '../../../../../../../../services/forms/formContentService';
import { drugReorder } from '../../../../../../../../utils/helpers/helpers';
import { useFormEdit } from '../../../../FormEditContext';

export default function DragableOptions({
  fields,
  setFields,
  selected,
  children,
}) {
  const [draggingId, setDraggingId] = useState();
  const { readOnly, reportError } = useFormEdit();

  const onDragEnd = (result) => {
    setDraggingId(null);
    if (
      !result.destination ||
      result.destination.index === result.source.index
    ) {
      return;
    }

    const previousFields = fields;
    const reorderedItems = drugReorder(
      fields,
      result.source.index,
      result.destination.index,
    );
    setFields(reorderedItems);

    // порядок целиком — как у вопросов (см. Questions.js)
    postReorderOptions(
      fields[result.source.index].question,
      reorderedItems.map((field) => field.uuid),
    )?.catch((err) => {
      setFields(previousFields);
      reportError(err, 'Не удалось сохранить порядок вариантов');
    });
  };

  const onDragStart = (start) => {
    setDraggingId(start.draggableId);
  };

  return (
    <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
      <StrictModeDroppable droppableId='contents'>
        {(provided) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            className='flex flex-col gap-4'
          >
            {children?.map((child, i) => {
              // children построены из fields в том же порядке; uuid варианта
              // стабилен при перестановке, в отличие от индекса
              const id = fields?.[i]?.uuid ?? i.toString();
              return (
                <Draggable
                  key={id}
                  draggableId={id}
                  index={i}
                  isDragDisabled={readOnly}
                >
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      // {...provided.dragHandleProps}
                      style={{
                        userSelect: 'none',
                        ...provided.draggableProps.style,
                      }}
                      className='relative'
                    >
                      <div
                        className={`group/option flex w-full flex-row items-center ${
                          snapshot.isDragging && 'opacity-50'
                        }`}
                      >
                        <div
                          {...provided.dragHandleProps}
                          className={`${
                            (draggingId && draggingId !== id) || !selected
                              ? ''
                              : 'group-hover/option:visible'
                          } ${
                            !snapshot.isDragging && 'invisible'
                          } w-6 text-secondary`}
                        >
                          <GripIcon className='h-4' />
                        </div>
                        {child}
                      </div>
                    </div>
                  )}
                </Draggable>
              );
            })}
            {provided.placeholder}
          </div>
        )}
      </StrictModeDroppable>
    </DragDropContext>
  ); // to translate
}
